export const form = {
    name: 'Nome',
    email: 'E-mail',
    phone: 'Telefono',
    state: 'Stato',
    city: 'Città',
    zipcode: 'Cap',
    uf: 'UF',
    role: 'Il tuo ruolo nel lavoro',
    required: 'Required',
    invalid: 'Invalido',
    newsletter: 'Vorrei ricevere le news di DeRosso per e-mail',
    button: 'Cerca rivenditori',
    error: 'one or more fields have an error. Please check and try again',
    request_error: 'Spiacenti, si è verificato un errore con la tua richiesta. Riprova.',
    success: 'Wait. We are doing your research.',
    professional: "Professionista specificatore (architetto, architetto d'interni, architetto paesaggista, ingegnere, ecc.)",
    consumer: 'Consumatore finale',
    others: 'Altro',
    call: 'Telefonata',
    contact_by: 'In che modo preferisci essere servito',
    header: 'Compila il modulo e parla con il<br> nostro servizio commerciale estero',
    alert: '* Tutti i campi sono obbligatori',
};

export const result = {
    no_results: "Grazie per l'interesse dimostrato per i prodotti DEROSSO. Riceverai un'email a breve",
    title: 'Risultato della ricerca',
    result: 'RESALE VICINO A TE',
    thanks: "Grazie per l'interesse dimostrato per i prodotti DEROSSO. Vedi sotto i negozi più vicini a CEP: {zipcode}",
    address: 'Indirizzo',
    phone: 'Telefono',
    zipcode: 'Codice postale',
    email: 'Email',
    city: 'Città',
    distance: 'Distanza',
    how_to_get: 'Come ottenere',
    button: 'TORNA',
    print: 'Stampare',
    send: 'Invia per email',
    innovation: 'Innovazione',
    architecture: 'Architettura',
    design: 'Disigno',
    success: 'Email inviata con successo',
    error: "Si è verificato un errore durante l'invio della tua email. :/",
};